


function addAltText_827cca0fbf8e4f279019077d6eea393f() {
  const altTextMap = [[".klaviyo-form-version-cid_3 > .needsclick.kl-private-reset-css-Xuajs1:nth-child(1) > .needsclick.kl-private-reset-css-Xuajs1 > img",{"selector":".klaviyo-form-version-cid_3 > .needsclick.kl-private-reset-css-Xuajs1:nth-child(1) > .needsclick.kl-private-reset-css-Xuajs1 > img","alt":"Modern Mammals hair care products including a bottle, refill pouch, soap bar, and box."}]];
  const selectorRouteMap = {".klaviyo-form-version-cid_9 > .needsclick.kl-private-reset-css-Xuajs1:nth-child(1) > .needsclick.kl-private-reset-css-Xuajs1 > img":["https://modernmammals.com/products/shampoo-light-bar","https://modernmammals.com/collections/merch","https://modernmammals.com/a/account/login","https://modernmammals.com/policies/privacy-policy","https://modernmammals.com/pages/about","https://modernmammals.com/blogs/blog"],".klaviyo-form-version-cid_3 > .needsclick.kl-private-reset-css-Xuajs1:nth-child(1) > .needsclick.kl-private-reset-css-Xuajs1 > img":["https://modernmammals.com/"]};

  function traverseSpecificElement(root, selector, callback) {
    const parts = selector.split('>>').map(s => s.trim());
    let currentElements = [root];

    for (const part of parts) {
      if (currentElements.length === 0) break;

      const nextElements = [];
      for (const element of currentElements) {
        if (element instanceof Document || element instanceof DocumentFragment) {
          nextElements.push(...element.querySelectorAll(part));
        } else if (element instanceof HTMLIFrameElement && element.contentDocument) {
          nextElements.push(...element.contentDocument.querySelectorAll(part));
        } else if (element.shadowRoot) {
          nextElements.push(...element.shadowRoot.querySelectorAll(part));
        } else {
          nextElements.push(...element.querySelectorAll(part));
          // Check for slotted elements
          if (element.assignedElements) {
            const slottedElements = element.assignedElements({ flatten: true });
            nextElements.push(...slottedElements.filter(el => el.matches(part)));
          }
        }
      }
      currentElements = nextElements;
    }

    currentElements.forEach(callback);
  }

  function isCurrentPageInRoutes(routes) {
    const currentPath = window.location.origin + window.location.pathname;
    return routes.some(route => {
      const routeRegex = new RegExp('^' + route.replace(/\*/g, '.*') + '$');
      return routeRegex.test(currentPath);
    });
  }

  altTextMap.forEach(([selector, value]) => {
    const routes = selectorRouteMap[selector];
    if (!routes || isCurrentPageInRoutes(routes)) {
      traverseSpecificElement(document, selector, (img) => {
        if ((img instanceof HTMLImageElement || img instanceof SVGElement) && (!img.alt || img.alt === "")) {
          
          img.alt = value.alt;
          
          img.setAttribute('data-alt-added', '827cca0fbf8e4f279019077d6eea393f');
        }
      });
    }
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addAltText_827cca0fbf8e4f279019077d6eea393f);
} else {
  addAltText_827cca0fbf8e4f279019077d6eea393f();
}

// Rerun the function when the DOM changes
const observer_827cca0fbf8e4f279019077d6eea393f = new MutationObserver(() => {
  addAltText_827cca0fbf8e4f279019077d6eea393f();
});
observer_827cca0fbf8e4f279019077d6eea393f.observe(document.body, { childList: true, subtree: true });

function fixAccessibility_f067c6751945431091c302f2b84b4f1e() {
    const interval = setInterval(() => {
        try {
            const targetElement = document.querySelector('a.acsb-sr-only');
            if (targetElement && !targetElement.closest('main, nav, footer, aside, header')) {
                let mainContent = document.querySelector('#MainContent');
                if (!mainContent) {
                    mainContent = document.createElement('main');
                    document.body.appendChild(mainContent);
                }
                mainContent.appendChild(targetElement);
                targetElement.setAttribute('data-accessibility-fix', 'f067c6751945431091c302f2b84b4f1e');
                clearInterval(interval);
            }
        } catch (error) {
            console.error('Error fixing accessibility issue:', error);
        }
    }, 1000);
}

fixAccessibility_f067c6751945431091c302f2b84b4f1e();

function fixAccessibility_6a7d937d5e2f48109e4e07620fe433ca() {
    const interval = setInterval(() => {
        try {
            const element = document.querySelector('#slideshow-thumbnails-template--17836435243241__featured_product_ixcWWe-list');
            if (element && element.getAttribute('aria-orientation') === 'vertical') {
                // Remove the invalid aria-orientation attribute
                element.removeAttribute('aria-orientation');
                // Add a data attribute to indicate the fix has been applied
                element.setAttribute('data-accessibility-fix', '6a7d937d5e2f48109e4e07620fe433ca');
                // Clear the interval as the fix has been applied
                clearInterval(interval);
                console.log('Accessibility fix applied to #slideshow-thumbnails-template--17836435243241__featured_product_ixcWWe-list');
            }
        } catch (error) {
            console.error('Error applying accessibility fix:', error);
        }
    }, 1000);
}

fixAccessibility_6a7d937d5e2f48109e4e07620fe433ca();


function addAltText_71912762e14541e78c5e639269825680() {
  const altTextMap = [["img[alt=\"Modern Mammals Hat\"]",{"selector":"img[alt=\"Modern Mammals Hat\"]","alt":"Navy blue baseball cap with 'quit shampoo.' embroidered on the front."}],["img[height=\"1050\"]",{"selector":"img[height=\"1050\"]","alt":"Person covered in snow, sitting outdoors with a frozen expression."}],["img[alt=\"Bar Travel Bag\"]",{"selector":"img[alt=\"Bar Travel Bag\"]","alt":"Modern Mammals shampoo bar in a travel bag with a blue starburst background."}],["img[alt=\"how to get surfer hair\"]",{"selector":"img[alt=\"how to get surfer hair\"]","alt":"Person with long hair talking on a vintage phone indoors."}],["img[alt=\"Meet Shampoo Light.\"]",{"selector":"img[alt=\"Meet Shampoo Light.\"]","alt":"Hand holding a round soap bar under running water in a tiled bathroom."}],["img[alt=\"Sample 3-Pack\"]",{"selector":"img[alt=\"Sample 3-Pack\"]","alt":"Three sachets of Modern Mammals Easy Rinse with brand logo and text."}],["img[alt=\"Bar Shower Tray\"]",{"selector":"img[alt=\"Bar Shower Tray\"]","alt":"Wooden tray with a stepped design."}],[".media-template--17836435734761__main-34919938785513 > .media-shape-container.z-10.relative > .media-image-container > .aspect-w-1.aspect-h-1.overflow-hidden > .foreign-object-img.object-cover.bg-scheme-card",{"selector":".media-template--17836435734761__main-34919938785513 > .media-shape-container.z-10.relative > .media-image-container > .aspect-w-1.aspect-h-1.overflow-hidden > .foreign-object-img.object-cover.bg-scheme-card","alt":"Box of Modern Mammals Shampoo Light with text 'Lighter Shampoo = Better Hair' on a green starburst background."}],[".media-template--17836435734761__main-34920047608041 > .media-shape-container.z-10.relative > .media-image-container > .aspect-w-1.aspect-h-1.overflow-hidden > .foreign-object-img.object-cover.bg-scheme-card",{"selector":".media-template--17836435734761__main-34920047608041 > .media-shape-container.z-10.relative > .media-image-container > .aspect-w-1.aspect-h-1.overflow-hidden > .foreign-object-img.object-cover.bg-scheme-card","alt":"Round shampoo bar next to a box with text 'Lighter Shampoo = Better Hair.'"}],[".media-template--17836435243241__featured_product_ixcWWe-35398500843753 > .object-wrapper.aspect-w-1.aspect-h-1 > .media-style[alt=\"Magic Mud 2 Pack Deal\"]",{"selector":".media-template--17836435243241__featured_product_ixcWWe-35398500843753 > .object-wrapper.aspect-w-1.aspect-h-1 > .media-style[alt=\"Magic Mud 2 Pack Deal\"]","alt":"Flowchart about shampoo preferences with a bottle of Modern Mammals Magic Mud on the side."}]];
  const selectorRouteMap = {"img[alt=\"Modern Mammals Hat\"]":["https://modernmammals.com/collections/merch"],"img[height=\"1050\"]":["https://modernmammals.com/blogs/blog"],"img[alt=\"Bar Travel Bag\"]":["https://modernmammals.com/products/shampoo-light-bar"],"img[alt=\"how to get surfer hair\"]":["https://modernmammals.com/blogs/blog"],"img[alt=\"Meet Shampoo Light.\"]":["https://modernmammals.com/blogs/blog"],"img[alt=\"Sample 3-Pack\"]":["https://modernmammals.com/collections/merch"],"img[alt=\"Bar Shower Tray\"]":["https://modernmammals.com/collections/merch"],".media-template--17836435734761__main-34919938785513 > .media-shape-container.z-10.relative > .media-image-container > .aspect-w-1.aspect-h-1.overflow-hidden > .foreign-object-img.object-cover.bg-scheme-card":["https://modernmammals.com/products/shampoo-light-bar"],".media-template--17836435734761__main-34920047608041 > .media-shape-container.z-10.relative > .media-image-container > .aspect-w-1.aspect-h-1.overflow-hidden > .foreign-object-img.object-cover.bg-scheme-card":["https://modernmammals.com/products/shampoo-light-bar"],".media-template--17836435243241__featured_product_ixcWWe-35398500843753 > .object-wrapper.aspect-w-1.aspect-h-1 > .media-style[alt=\"Magic Mud 2 Pack Deal\"]":["https://modernmammals.com/"],".media-template--17836435734761__main-34920347893993 > .media-shape-container.z-10.relative > .media-image-container > .aspect-w-1.aspect-h-1.overflow-hidden > .foreign-object-img.object-cover.bg-scheme-card":["https://modernmammals.com/products/shampoo-light-bar"],".media-FeatureMedia-template--17836435734761__main-34919938785513 > .media-content > .media-style.bg-scheme-card[sizes=\"(min-width: 990px) 50vw, 100vw\"]":["https://modernmammals.com/products/shampoo-light-bar"]};

  function traverseSpecificElement(root, selector, callback) {
    const parts = selector.split('>>').map(s => s.trim());
    let currentElements = [root];

    for (const part of parts) {
      if (currentElements.length === 0) break;

      const nextElements = [];
      for (const element of currentElements) {
        if (element instanceof Document || element instanceof DocumentFragment) {
          nextElements.push(...element.querySelectorAll(part));
        } else if (element instanceof HTMLIFrameElement && element.contentDocument) {
          nextElements.push(...element.contentDocument.querySelectorAll(part));
        } else if (element.shadowRoot) {
          nextElements.push(...element.shadowRoot.querySelectorAll(part));
        } else {
          nextElements.push(...element.querySelectorAll(part));
          // Check for slotted elements
          if (element.assignedElements) {
            const slottedElements = element.assignedElements({ flatten: true });
            nextElements.push(...slottedElements.filter(el => el.matches(part)));
          }
        }
      }
      currentElements = nextElements;
    }

    currentElements.forEach(callback);
  }

  function isCurrentPageInRoutes(routes) {
    const currentPath = window.location.origin + window.location.pathname;
    return routes.some(route => {
      const routeRegex = new RegExp('^' + route.replace(/\*/g, '.*') + '$');
      return routeRegex.test(currentPath);
    });
  }

  altTextMap.forEach(([selector, value]) => {
    const routes = selectorRouteMap[selector];
    if (!routes || isCurrentPageInRoutes(routes)) {
      traverseSpecificElement(document, selector, (img) => {
        if (img instanceof HTMLImageElement || img instanceof SVGElement) {
          
          img.alt = value.alt;
          
          img.setAttribute('data-alt-added', '71912762e14541e78c5e639269825680');
        }
      });
    }
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addAltText_71912762e14541e78c5e639269825680);
} else {
  addAltText_71912762e14541e78c5e639269825680();
}

// Rerun the function when the DOM changes
const observer_71912762e14541e78c5e639269825680 = new MutationObserver(() => {
  addAltText_71912762e14541e78c5e639269825680();
});
observer_71912762e14541e78c5e639269825680.observe(document.body, { childList: true, subtree: true });


function addAltText_a596ff7a4c834cde83122b2528281562() {
  const altTextMap = [[".jdgm-carousel-item:nth-child(5) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Shampoo Light Bar\"]",{"selector":".jdgm-carousel-item:nth-child(5) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Shampoo Light Bar\"]","alt":"Box of shampoo with text 'Shampoo & Better Hair' on a green starburst background."}],[".jdgm-carousel-item:nth-child(9) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Shampoo Light Bar\"]",{"selector":".jdgm-carousel-item:nth-child(9) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Shampoo Light Bar\"]","alt":"Box of shampoo with text 'Shampoo & Better Hair' on a green starburst background."}],[".jdgm-carousel-item:nth-child(6) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Shampoo Light Bar\"]",{"selector":".jdgm-carousel-item:nth-child(6) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Shampoo Light Bar\"]","alt":"Box of shampoo with text 'Shampoo & Better Hair' on a green starburst background."}],[".jdgm-carousel-item:nth-child(11) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]",{"selector":".jdgm-carousel-item:nth-child(11) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]","alt":"Pouch and bottle set with abstract design and text 'modern mammals'."}],[".jdgm-carousel-item:nth-child(4) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]",{"selector":".jdgm-carousel-item:nth-child(4) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]","alt":"Pouch and bottle set with abstract design and text 'modern mammals'."}],[".jdgm-carousel-item:nth-child(14) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]",{"selector":".jdgm-carousel-item:nth-child(14) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]","alt":"Pouch and bottle set with abstract design and text 'modern mammals'."}],[".jdgm-carousel-item:nth-child(8) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]",{"selector":".jdgm-carousel-item:nth-child(8) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]","alt":"Pouch and bottle set with abstract design and text 'modern mammals'."}],[".jdgm-carousel-item:nth-child(15) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]",{"selector":".jdgm-carousel-item:nth-child(15) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]","alt":"Pouch and bottle set with abstract design and text 'modern mammals'."}],[".jdgm-carousel-item:nth-child(1) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]",{"selector":".jdgm-carousel-item:nth-child(1) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]","alt":"Pouch and bottle set with abstract design and text 'modern mammals'."}],[".jdgm-carousel-item:nth-child(12) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]",{"selector":".jdgm-carousel-item:nth-child(12) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]","alt":"Pouch and bottle set with abstract design and text 'modern mammals'."}],[".jdgm-carousel-item:nth-child(2) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]",{"selector":".jdgm-carousel-item:nth-child(2) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]","alt":"Product packaging featuring a pouch and bottle with abstract design."}],[".jdgm-carousel-item:nth-child(13) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]",{"selector":".jdgm-carousel-item:nth-child(13) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]","alt":"Product packaging featuring a pouch and bottle with abstract design."}],[".jdgm-carousel-item:nth-child(7) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]",{"selector":".jdgm-carousel-item:nth-child(7) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]","alt":"Product packaging featuring a pouch and bottle with abstract design."}],[".jdgm-carousel-item:nth-child(3) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]",{"selector":".jdgm-carousel-item:nth-child(3) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]","alt":"Product packaging featuring a pouch and bottle with abstract design."}]];
  const selectorRouteMap = {".jdgm-carousel-item:nth-child(5) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Shampoo Light Bar\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(9) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Shampoo Light Bar\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(6) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Shampoo Light Bar\"]":["https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(11) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(4) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(14) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(8) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(15) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(1) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(12) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(2) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(13) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(7) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"],".jdgm-carousel-item:nth-child(3) > .jdgm-carousel-item__product.jdgm--shop-review-has-image > .jdgm-carousel-item__product-image[alt=\"Magic Mud\"]":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar"]};

  function traverseSpecificElement(root, selector, callback) {
    const parts = selector.split('>>').map(s => s.trim());
    let currentElements = [root];

    for (const part of parts) {
      if (currentElements.length === 0) break;

      const nextElements = [];
      for (const element of currentElements) {
        if (element instanceof Document || element instanceof DocumentFragment) {
          nextElements.push(...element.querySelectorAll(part));
        } else if (element instanceof HTMLIFrameElement && element.contentDocument) {
          nextElements.push(...element.contentDocument.querySelectorAll(part));
        } else if (element.shadowRoot) {
          nextElements.push(...element.shadowRoot.querySelectorAll(part));
        } else {
          nextElements.push(...element.querySelectorAll(part));
          // Check for slotted elements
          if (element.assignedElements) {
            const slottedElements = element.assignedElements({ flatten: true });
            nextElements.push(...slottedElements.filter(el => el.matches(part)));
          }
        }
      }
      currentElements = nextElements;
    }

    currentElements.forEach(callback);
  }

  function isCurrentPageInRoutes(routes) {
    const currentPath = window.location.origin + window.location.pathname;
    return routes.some(route => {
      const routeRegex = new RegExp('^' + route.replace(/\*/g, '.*') + '$');
      return routeRegex.test(currentPath);
    });
  }

  altTextMap.forEach(([selector, value]) => {
    const routes = selectorRouteMap[selector];
    if (!routes || isCurrentPageInRoutes(routes)) {
      traverseSpecificElement(document, selector, (img) => {
        if (img instanceof HTMLImageElement || img instanceof SVGElement) {
          
          img.alt = value.alt;
          
          img.setAttribute('data-alt-added', 'a596ff7a4c834cde83122b2528281562');
        }
      });
    }
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addAltText_a596ff7a4c834cde83122b2528281562);
} else {
  addAltText_a596ff7a4c834cde83122b2528281562();
}

// Rerun the function when the DOM changes
const observer_a596ff7a4c834cde83122b2528281562 = new MutationObserver(() => {
  addAltText_a596ff7a4c834cde83122b2528281562();
});
observer_a596ff7a4c834cde83122b2528281562.observe(document.body, { childList: true, subtree: true });

function fixAccessibility_e2df4ea4115a4f168f3f9e92c144bda0() {
    const targetSelectors = [
        'ul#slideshow-template--17836435243241__16508916323f758a49-list',
        'ul#slideshow-template--17836435734761__main-list',
        'ul#slideshow-template--17836435243241__featured_product_ixcWWe-list'
    ];
    let intervalId = setInterval(() => {
        let allFixed = true;

        targetSelectors.forEach(selector => {
            const element = document.querySelector(selector);
            if (element && element.getAttribute('role') === 'presentation') {
                element.setAttribute('role', 'list');
                element.setAttribute('data-accessibility-fix', 'e2df4ea4115a4f168f3f9e92c144bda0');
                console.log(`Fixed accessibility for ${selector}`);
            } else if (!element) {
                allFixed = false; // If the element is not yet in the DOM, keep the interval running
            }
        });
    }, 1000);

    // Listen for messages from iframes
    window.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'fixAccessibility') {
            const iframeDocument = event.source.document;
            targetSelectors.forEach(selector => {
                const element = iframeDocument.querySelector(selector);
                if (element && element.getAttribute('role') === 'presentation') {
                    element.setAttribute('role', 'list');
                    element.setAttribute('data-accessibility-fix', 'e2df4ea4115a4f168f3f9e92c144bda0');
                    console.log(`Fixed accessibility in iframe for ${selector}`);
                }
            });
        }
    });
}

// Call the function to start the fixing process
fixAccessibility_e2df4ea4115a4f168f3f9e92c144bda0();


function addAltText_4bfd75c13fda4be7ab016b62d08cf06b() {
  const altTextMap = [[".klaviyo-form-version-cid_9 > .needsclick.kl-private-reset-css-Xuajs1:nth-child(1) > .needsclick.kl-private-reset-css-Xuajs1 > img",{"selector":".klaviyo-form-version-cid_9 > .needsclick.kl-private-reset-css-Xuajs1:nth-child(1) > .needsclick.kl-private-reset-css-Xuajs1 > img","alt":"Collection of Modern Mammals hair care products including a bottle, pouch, soap bar, and box with colorful geometric designs."}]];
  const selectorRouteMap = {".klaviyo-form-version-cid_9 > .needsclick.kl-private-reset-css-Xuajs1:nth-child(1) > .needsclick.kl-private-reset-css-Xuajs1 > img":["https://modernmammals.com/","https://modernmammals.com/products/shampoo-light-bar","https://modernmammals.com/collections/merch","https://modernmammals.com/a/account/login","https://modernmammals.com/policies/privacy-policy","https://modernmammals.com/pages/about","https://modernmammals.com/blogs/blog"]};

  function traverseSpecificElement(root, selector, callback) {
    const parts = selector.split('>>').map(s => s.trim());
    let currentElements = [root];

    for (const part of parts) {
      if (currentElements.length === 0) break;

      const nextElements = [];
      for (const element of currentElements) {
        if (element instanceof Document || element instanceof DocumentFragment) {
          nextElements.push(...element.querySelectorAll(part));
        } else if (element instanceof HTMLIFrameElement && element.contentDocument) {
          nextElements.push(...element.contentDocument.querySelectorAll(part));
        } else if (element.shadowRoot) {
          nextElements.push(...element.shadowRoot.querySelectorAll(part));
        } else {
          nextElements.push(...element.querySelectorAll(part));
          // Check for slotted elements
          if (element.assignedElements) {
            const slottedElements = element.assignedElements({ flatten: true });
            nextElements.push(...slottedElements.filter(el => el.matches(part)));
          }
        }
      }
      currentElements = nextElements;
    }

    currentElements.forEach(callback);
  }

  function isCurrentPageInRoutes(routes) {
    const currentPath = window.location.origin + window.location.pathname;
    return routes.some(route => {
      const routeRegex = new RegExp('^' + route.replace(/\*/g, '.*') + '$');
      return routeRegex.test(currentPath);
    });
  }

  altTextMap.forEach(([selector, value]) => {
    const routes = selectorRouteMap[selector];
    if (!routes || isCurrentPageInRoutes(routes)) {
      traverseSpecificElement(document, selector, (img) => {
        if (img instanceof HTMLImageElement || img instanceof SVGElement) {
          
          img.alt = value.alt;
          
          img.setAttribute('data-alt-added', '4bfd75c13fda4be7ab016b62d08cf06b');
        }
      });
    }
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addAltText_4bfd75c13fda4be7ab016b62d08cf06b);
} else {
  addAltText_4bfd75c13fda4be7ab016b62d08cf06b();
}

// Rerun the function when the DOM changes
const observer_4bfd75c13fda4be7ab016b62d08cf06b = new MutationObserver(() => {
  addAltText_4bfd75c13fda4be7ab016b62d08cf06b();
});
observer_4bfd75c13fda4be7ab016b62d08cf06b.observe(document.body, { childList: true, subtree: true });

function fixAccessibility_f501ed5073394091b1c45b75f6d325eb() {
    const intervalId = setInterval(() => {
        try {
            const elements = document.querySelectorAll('div.styles_CartPreview__card__KX-WB:not([data-accessibility-fix="f501ed5073394091b1c45b75f6d325eb"])');
            let allFixed = true;

            elements.forEach(element => {
                if (!element.hasAttribute('role')) {
                    element.setAttribute('role', 'region');
                    element.setAttribute('aria-label', 'Cart Preview');
                    element.setAttribute('data-accessibility-fix', 'f501ed5073394091b1c45b75f6d325eb');
                } else {
                    allFixed = false;
                }
            });

            if (allFixed) {
                clearInterval(intervalId);
            }
        } catch (error) {
            console.error('Error applying accessibility fix:', error);
        }
    }, 1000);

    window.addEventListener('message', (event) => {
        if (event.data === 'applyAccessibilityFix') {
            fixAccessibility_f501ed5073394091b1c45b75f6d325eb();
        }
    });
}

fixAccessibility_f501ed5073394091b1c45b75f6d325eb();

function fixAccessibility_5580fe62e7564f5f94705e5aae8103b2() {
    function applyFix() {
        const cartPopup = document.querySelector('#CartPopup');
        if (cartPopup && !cartPopup.hasAttribute('tabindex')) {
            cartPopup.setAttribute('tabindex', '0');
            cartPopup.setAttribute('data-accessibility-fix', '5580fe62e7564f5f94705e5aae8103b2');
            console.log('Accessibility fix applied to #CartPopup');
            return true;
        }
        return false;
    }

    function checkAndApplyFix() {
        try {
            if (applyFix()) {
                clearInterval(interval);
            }
        } catch (error) {
            console.error('Error applying accessibility fix:', error);
        }
    }

    const interval = setInterval(checkAndApplyFix, 1000);

    window.addEventListener('message', function(event) {
        if (event.data === 'applyAccessibilityFix') {
            checkAndApplyFix();
        }
    }, false);
}

fixAccessibility_5580fe62e7564f5f94705e5aae8103b2();